import PropTypes from 'prop-types';
import React from 'react';

const TRANSITIONED_PROPERTY = 'max-height';

const SegmentedPassage = (props) => {
    const wrapperClass = (segmentIndex) => (segmentIndex > props.activeSegmentIndex ? '' : 'expanded');
    const segmentClass = (segmentIndex) => {
        const isVisible = segmentIndex === props.activeSegmentIndex && !props.isActiveSegmentHidden;
        return `${isVisible ? '' : ' fluency-obscure'}`;
    };
    const onTransitionEnd = (transition) => {
        if (transition.propertyName === TRANSITIONED_PROPERTY && !props.isActiveSegmentHidden) {
            props.onShow();
        }
    };
    return (
        <div className="fluency-text">
            {props.activeSegmentIndex !== undefined && props.segments.map((segment, i) => (
                <div
                    className={`fluency-segment-wrapper ${wrapperClass(i)}`}
                    onTransitionEnd={onTransitionEnd}
                    key={`wrapper-${segment.id}`}>
                    <p
                        className={`fluency-active${segmentClass(i)}`}
                        key={`segment-${segment.id}`}>
                        <span>{segment.text}</span>
                    </p>
                </div>
            ))}
        </div>
    );
};
/* eslint-disable react/no-unused-prop-types */
SegmentedPassage.propTypes = {
    segments: PropTypes.arrayOf(PropTypes.object).isRequired,
    activeSegmentIndex: PropTypes.number,
    isActiveSegmentHidden: PropTypes.bool,
    onShow: PropTypes.func,
};
/* eslint-enable react/no-unused-prop-types */

SegmentedPassage.defaultProps = {
    activeSegmentIndex: undefined,
    isActiveSegmentHidden: false,
    onShow: () => {},
};

export default SegmentedPassage;
